import { ISortConfig } from '../api/common/addresses';
import {
  addressDefaultSortConfigs,
  AddressSortByLabel,
} from '../constants/sort';

export const generateSortByOptions = (
  sortByLabel: AddressSortByLabel,
  options?: Pick<ISortConfig, 'page' | 'ascendingOrder'>,
): ISortConfig => {
  return {
    ...addressDefaultSortConfigs[sortByLabel],
    ...(options || {}),
  };
};
